import {LoginState} from '~/src/utilities/constants/login';
import {userIsLoggedIn, userHasSession, refreshUser, resetUser} from '~/src/utilities/helpers/account';
import {Cookie} from '~/src/utilities/constants/cookie';
import {getCookie} from '~/src/utilities/helpers/cookie';
import {Feature} from '~/src/utilities/constants/feature';
import {Time} from '~/src/utilities/constants/time';
import {isEnabled} from '~/src/utilities/helpers/feature';
import rollbar from '~/src/utilities/libs/rollbar';

const refreshOrShouldLogin = async (isLoggedIn) => {
    if (isLoggedIn && !userHasSession()) {
        try {
            await refreshUser();
        } catch (ex) {
            return true;
        }
    }

    return false;
};

const getLoginState = async () => {
    if (!userIsLoggedIn()) {
        return LoginState.ANONYMOUS;
    }

    if (userHasSession()) {
        return LoginState.ACCOUNT;
    }

    try {
        await refreshUser();

        return LoginState.ACCOUNT;
    } catch (error) {
        if (error.statusCode !== 401 && error.statusCode !== 500) {
            rollbar.info(`[login] Unexpected error when refreshing user: ${error.message}`, error);
        }

        resetUser();
    }

    return LoginState.ANONYMOUS;
};

const checkLoginModal = (isWebView) => {
    //it's shown on 1st contact and every 4 days again
    let loginModalTimestamp;

    try {
        loginModalTimestamp = localStorage.getItem('loginModalTimestamp');
    } catch (error) {
        rollbar.info(`[login] Browser does not support LocalStorage API: ${error.message}`, error);
    }

    const showUpTime = Time.TWO_DAYS;

    // control group: 10% of the user never see the login modal (keep the same as on legacy: _ga cookie on .20min.ch ends with 0)
    const gaCookie = getCookie(Cookie.GA);
    const gaCookieNotNull = gaCookie && gaCookie.slice(-1) !== '0';

    const oldURL = document.referrer || '';
    const was20minLastSite = oldURL.includes('20min') || oldURL.includes('localhost') || oldURL === '';

    return (
        isEnabled(Feature.LOGIN_MODAL) &&
        was20minLastSite &&
        !isWebView &&
        gaCookieNotNull &&
        !userIsLoggedIn() &&
        (!loginModalTimestamp || loginModalTimestamp + showUpTime < Date.now())
    );
};

export {refreshOrShouldLogin, getLoginState, checkLoginModal};
